const defaultContext = ['mainCookie', 'abTests'];

const domainLabelLearnMoreClick = (labelType) => ({
  tracker: 'trackStructEvent',
  data: {
    category: labelType,
    action: 'click',
    label: 'learn_more',
  },
  context: defaultContext,
});

export default domainLabelLearnMoreClick;
